import React, { Component } from "react";
import { Box, Typography } from "@mui/material";
import { isMobile } from "react-device-detect";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught by ErrorBoundary: ", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{display:"flex", justifyContent:"center", alignItems: "center", flexDirection: "column", height: "100vh"}}>
          <img height={150} src="/attachments/Logos/logo.png" alt="logo" />
          <Typography variant={isMobile ? "h4" :"h3"}>نعتذر خدث خطأ بالنظام, يرجى المحاولة فيما بعد.</Typography>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
